var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRomania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 400,
    viewBox: "0 0 3 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 0,
    y: 0,
    fill: "#002B7F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 1,
    y: 0,
    fill: "#FCD116"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 2,
    y: 0,
    fill: "#CE1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRomania);
export default __webpack_public_path__ + "static/media/flag-romania.8b892c753aee9146eda6a8ba5622fcd4.svg";
export { ForwardRef as ReactComponent };